import { render, staticRenderFns } from "./brandInfoNew.vue?vue&type=template&id=3a4ca476&scoped=true&"
import script from "./brandInfoNew.vue?vue&type=script&lang=js&"
export * from "./brandInfoNew.vue?vue&type=script&lang=js&"
import style0 from "./brandInfoNew.vue?vue&type=style&index=0&id=3a4ca476&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4ca476",
  null
  
)

export default component.exports